'use client'
import React, { useState } from 'react'
import "./style.css"
import HostedCardSetup from '../HostedCardSetup/page';
import PrefixIconButton from '../buttons/prefixIconButton';
import formatMsg from '../../util/formatMsg';
import { CloseOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { Helper } from '../..';
import { useRouter } from 'next/navigation';

const page = ({ showBookingConfirmation, setShowBookingConfirmation, bookingDetails, firebase }) => {
    const router = useRouter();
    const [cardDone, setCardDone] = useState(false); // Proceed-first: card added on Stripe -> autopay active
    const closePopup = () => {
        setShowBookingConfirmation(false);
    };
    function isLoggedIn() {
        return firebase?.user?.id;
    }
    const isTeacher = isLoggedIn() && !Helper.isAccount(firebase)
    return (
        <div>
            <>
                {showBookingConfirmation && (
                    <div>
                        <div className="booking-confirmation-overlay">
                            <div className="booking-confirmation-popup">
                                <div className="confirm-booking-container">
                                    <div className="confirm-booking-left-container">
                                        <div>
                                            <img className="confirm-booking-icon" src="/images/confirm-circle.png" alt="confirm-circle" />
                                        </div>
                                        <div className="confirm-booking-title">
                                            {bookingDetails?.approvalRequired
                                                ? formatMsg("confirmPopup.bookingRequested")
                                                : bookingDetails?.allWaitlisted
                                                    ? "Added to Waitlist"
                                                    : bookingDetails?.hasWaitlisted
                                                        ? "Booking Created"
                                                        : formatMsg("bookingConfirmed")}
                                        </div>
                                        <div className="confirm-booking-left-subtitle">
                                            {bookingDetails?.hasWaitlisted
                                                ? "Some participants are on the waitlist. You'll be notified when they're confirmed."
                                                : formatMsg("confirmationEmail")}
                                        </div>
                                        {bookingDetails?.autopayPendingCard && bookingDetails?.accountDetail?.id && (
                                            <div style={{ margin: "14px 0", padding: 12, borderRadius: 8, background: "#F6F0FF", textAlign: "center" }}>
                                                {cardDone ? (
                                                    <div style={{ fontSize: 13, color: "#00855A", fontWeight: 600 }}>{"✓ "}{formatMsg("autopay.activeNow")}</div>
                                                ) : (
                                                    <>
                                                        <div style={{ fontSize: 12, color: "#6B4BA1", marginBottom: 8 }}>{formatMsg("autopay.finishHint")}</div>
                                                        {/* Bound to the bookings this purchase created only — never the family's other bookings waiting for a card. */}
                                                        <HostedCardSetup accountId={bookingDetails.accountDetail.id} onSaved={() => setCardDone(true)}
                                                            bindTo={Array.isArray(bookingDetails?.bookingIds) ? { bookingIds: bookingDetails.bookingIds } : undefined} />
                                                    </>
                                                )}
                                            </div>
                                        )}
                                        {isLoggedIn() &&
                                            <PrefixIconButton
                                                type={"primary"}
                                                title={formatMsg("viewBooking")}
                                                borderRadius={"8px"}
                                                padding={"4px 20px"}
                                                maxWidth={"201px"}
                                                minWidth={"126px"}
                                                minHeight={"32px"}
                                                onClick={() => {
                                                    isTeacher ? router.push("/dashboard/booking") : router.push(bookingDetails?.isDeferred ? "/dashboard/myMemberships" : "/dashboard/myBookings")
                                                }}
                                            />}
                                        <PrefixIconButton
                                            title={formatMsg("goHome")}
                                            borderRadius={"8px"}
                                            border={true}
                                            padding={"4px 20px"}
                                            maxWidth={"201px"}
                                            minWidth={"126px"}
                                            minHeight={"32px"}
                                            onClick={() => {
                                                isTeacher ? router.push("/dashboard") : router.push("/dashboard")
                                            }}
                                        />
                                    </div>

                                    <div className="confirm-booking-right-container">
                                        <Button
                                            type="text"
                                            icon={<CloseOutlined />}
                                            className="confirm-booking-close-btn"
                                            onClick={closePopup}
                                        />
                                        <div className="confirm-booking-right-subcontainer">
                                            <div className="confirm-booking-right-title">{formatMsg("bookingDetails")}</div>
                                            {bookingDetails?.bookingNumbers && (() => {
                                                const numbers = bookingDetails.bookingNumbers.split(", ").map(n => n.trim());
                                                const statuses = bookingDetails.bookingStatuses || [];
                                                return numbers.map((num, i) => (
                                                    <div key={num} className="booking-detail-inf">
                                                        {num}
                                                        {statuses[i] && (
                                                            <span style={{
                                                                marginInlineStart: 8,
                                                                fontSize: 12,
                                                                padding: "2px 8px",
                                                                borderRadius: 12,
                                                                backgroundColor: statuses[i] === "WAITLISTED" ? "#FFF3D4" : "#D4EFDF",
                                                                color: statuses[i] === "WAITLISTED" ? "#7D5800" : "#00855A"
                                                            }}>
                                                                {statuses[i] === "WAITLISTED" ? "Waitlisted" : statuses[i] === "CONFIRMATION_PENDING" ? "Pending" : "Confirmed"}
                                                            </span>
                                                        )}
                                                    </div>
                                                ));
                                            })()}
                                            <div className="confirm-booking-inf-container">
                                                <div className="booking-inf-container">
                                                    <div className="booking-detail-title">{formatMsg("centerDetails")}</div>
                                                    {bookingDetails?.centerName && <div className="booking-detail-inf">{formatMsg("centerName") + ": " + bookingDetails.centerName}</div>}
                                                    {bookingDetails?.batchName && <div className="booking-detail-inf">{formatMsg("batch") + ": " + bookingDetails.batchName}</div>}
                                                </div>

                                                <div className="booking-inf-container confirm-booking-margin-top">
                                                    <div className="booking-detail-title">
                                                        {
                                                            formatMsg(
                                                                "participantDetails",
                                                                {
                                                                    Participant: Helper.getSelectedUserTypeName(
                                                                        firebase,
                                                                        formatMsg('participant')
                                                                    )
                                                                }
                                                            )
                                                        }
                                                    </div>
                                                    {bookingDetails?.profileDetails?.map((profile, index) => (
                                                        <div key={profile?.id || index}>
                                                            {profile?.name && <div className="booking-detail-inf">{formatMsg("name") + ": " + profile.name}</div>}
                                                            {/* <div className="participant-inf">
                                                            {profile?.age && <div className="booking-detail-inf">{formatMsg("age") + ": " + profile.age}</div>}
                                                            {profile?.gender && <div className="booking-detail-inf">{formatMsg("gender") + ": " + profile.gender}</div>}
                                                        </div> */}
                                                        </div>
                                                    ))}
                                                </div>

                                                <div className="booking-inf-container confirm-booking-margin-top">
                                                    <div className="booking-detail-title">{formatMsg("contactInformation")}</div>
                                                    {bookingDetails?.accountDetail?.name && <div className="booking-detail-inf">
                                                        {formatMsg("name") + ": " + bookingDetails.accountDetail.name}
                                                    </div>}
                                                    {bookingDetails?.accountDetail?.email && <div className="booking-detail-inf">
                                                        {formatMsg("email") + ": " + bookingDetails.accountDetail.email}
                                                    </div>}
                                                    {bookingDetails?.accountDetail?.phoneNumber && <div className="booking-detail-inf">
                                                        {formatMsg("contactNumber") + ": " + bookingDetails.accountDetail.phoneNumber}
                                                    </div>}
                                                </div>

                                                {/* Render additional fields with sections structure */}
                                                {bookingDetails?.additionalFieldSections && bookingDetails.additionalFieldSections.length > 0 ? (
                                                    bookingDetails.additionalFieldSections.map((section, sectionIndex) => {
                                                        if (!section.additionalFields || section.additionalFields.length === 0) return null;
                                                        return (
                                                            <div key={section.id || sectionIndex} className="booking-inf-container confirm-booking-margin-top">
                                                                <div className="booking-detail-title">{section.sectionHeading || formatMsg("additionalFields")}</div>
                                                                {section.additionalFields.map((field, index) =>
                                                                    <div className="booking-detail-inf" key={index}>
                                                                        {field.name + ": " + Helper.getFieldValueByDatatype(field, firebase)}
                                                                    </div>
                                                                )}
                                                            </div>
                                                        );
                                                    })
                                                ) : (
                                                    // Fallback to old structure (backward compatibility)
                                                    bookingDetails?.additionalFields && bookingDetails?.additionalFields.length > 0 && (
                                                        <div className="booking-inf-container confirm-booking-margin-top">
                                                            <div className="booking-detail-title">{bookingDetails?.additionalFieldHeading ? bookingDetails?.additionalFieldHeading : formatMsg("additionalFields")}</div>
                                                            {bookingDetails?.additionalFields?.map((field, index) =>
                                                                <div className="booking-detail-inf" key={index}>
                                                                    {field.name + ": " + Helper.getFieldValueByDatatype(field, firebase)}
                                                                </div>
                                                            )}
                                                        </div>
                                                    )
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </>
        </div>
    )
}

export default page
